import Abstract from './../Abstract'
import { TimelineLite, CSSPlugin, AttrPlugin } from "gsap/all";

const plugins = { CSSPlugin, AttrPlugin }

export default class Animation extends Abstract {

    constructor( autobuild = true, autoplay = false ) {
        super( 'Animation' );
        if ( this.constructor === Animation ) {
            this.__instanceError();
        }

        this.timeline = new TimelineLite({
            paused: ! autoplay,
            onComplete: this.onComplete,
            onCompleteScope: this,
            onReverseComplete: this.onReverseComplete,
            onReverseCompleteScope: this
        });

        if(autobuild) this.build()
    }

    static key() { Abstract.methodError( 'Animation', 'key' )  }

    clear() { return this }

    onComplete() { return null }

    onReverseComplete() { return null }

    build() { this.__methodError( 'build' ) }

    play() { this.timeline.play() }

    reverse() { this.timeline.reverse() }
}